module.exports = __webpack_public_path__ + "img/remove-payment-ico.2106b6a2.svg";